import { apiClient } from './client';

/**
 * 내 서명 · 도장 (2026-08-28 · 자리 재정의 판 8).
 *
 * 서버: `apps/chat-server/src/modules/approval/signature.routes.ts`.
 *
 * ★★ **서명은 결재의 조건이 아니다.** 등록 안 해도 결재되고 «이름 도장»이 남는다.
 * ★★ **바꿔도 지난 도장은 안 변한다.** 서버가 판마다 새 객체에 쓰고, 지난 문서의 줄은
 *    찍을 때의 것을 이고 있다 — 그래서 그림 주소가 **줄마다** 다르다.
 * ★ 옛 서버는 이 라우트를 모른다(404) — 그때는 화면이 이름만 그린다.
 */

export type SignatureKind = 'NAME' | 'DRAW' | 'UPLOAD';

export interface MySignatureDto {
  kind: SignatureKind;
  hasImage: boolean;
  /** 그림 주소의 캐시를 가르는 값 — 판이 바뀌면 이것도 바뀐다. */
  version: string | null;
  updatedAt: string | null;
}

export async function fetchMySignature(): Promise<MySignatureDto> {
  const { data } = await apiClient.get<MySignatureDto>('/approval/signature');
  return data;
}

export interface SaveSignatureInput {
  kind: SignatureKind;
  /** `NAME` 이면 안 보낸다. */
  contentType?: string;
  /** base64 (PNG · WEBP). */
  data?: string;
}

export async function saveMySignature(input: SaveSignatureInput): Promise<MySignatureDto> {
  const { data } = await apiClient.put<MySignatureDto>('/approval/signature', input);
  return data;
}

/** 지우기 — **이름 도장으로 돌아간다**(결재를 못 하게 되는 것이 아니다). */
export async function deleteMySignature(): Promise<MySignatureDto> {
  const { data } = await apiClient.delete<MySignatureDto>('/approval/signature');
  return data;
}

// ★ 그림은 `<img src>` 가 **쿠키 인증으로 직접** 부른다(아바타와 같은 방식) — 그래서
//   apiClient 가 아니라 주소만 만든다. 베이스는 avatar-src.ts 와 같은 값을 본다.
const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api/v1';

/** 내 서명 그림 주소 — 판을 붙여 캐시를 가른다. */
export function mySignatureImageUrl(version: string | null): string {
  return `${API_BASE}/approval/signature/image${version ? `?v=${version}` : ''}`;
}

/**
 * 그 줄에 **찍힌** 그림 주소.
 *
 * ★ 「지금 그 사람의 서명」이 아니다 — 줄이 이고 있는 그림이라 문서마다 다를 수 있다.
 */
export function stampImageUrl(documentId: string, lineId: string): string {
  return `${API_BASE}/approval/documents/${documentId}/lines/${lineId}/stamp`;
}
